import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIList from 'UIComponents/list/UIList';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getDefaultSorts = (order, primaryDisplayLabelPropertyName, secondaryDisplayLabelPropertyNames) => [{
  property: primaryDisplayLabelPropertyName,
  order
}, ...(secondaryDisplayLabelPropertyNames !== null && secondaryDisplayLabelPropertyNames !== void 0 ? secondaryDisplayLabelPropertyNames : []).map(property => ({
  property,
  order
}))];
export const OPTIONS = [{
  id: 'alphaAsc',
  textKey: 'automation.testV2.chooseRecordPanel.sort.alphaAsc',
  iconName: 'sortAlpAsc',
  getSorts: (primaryDisplayLabelPropertyName, secondaryDisplayLabelPropertyNames) => getDefaultSorts('ASC', primaryDisplayLabelPropertyName, secondaryDisplayLabelPropertyNames)
}, {
  id: 'alphaDesc',
  textKey: 'automation.testV2.chooseRecordPanel.sort.alphaDesc',
  iconName: 'sortAlpDesc',
  getSorts: (primaryDisplayLabelPropertyName, secondaryDisplayLabelPropertyNames) => getDefaultSorts('DESC', primaryDisplayLabelPropertyName, secondaryDisplayLabelPropertyNames)
}, {
  id: 'dateDesc',
  textKey: 'automation.testV2.chooseRecordPanel.sort.lastUpdated',
  iconName: 'sortAmtDesc',
  getSorts: () => [{
    property: 'notes_last_updated',
    order: 'DESC'
  }, {
    property: 'createdate',
    order: 'DESC'
  }]
}, {
  id: 'dateAsc',
  textKey: 'automation.testV2.chooseRecordPanel.sort.firstUpdated',
  iconName: 'sortAmtAsc',
  getSorts: () => [{
    property: 'notes_last_updated',
    order: 'ASC'
  }, {
    property: 'createdate',
    order: 'DESC'
  }]
}, {
  id: 'createdDesc',
  textKey: 'automation.testV2.chooseRecordPanel.sort.lastCreated',
  iconName: 'sortAmtDesc',
  getSorts: (primaryDisplayLabelPropertyName, secondaryDisplayLabelPropertyNames) => [{
    property: 'createdate',
    order: 'DESC'
  }, ...getDefaultSorts('ASC', primaryDisplayLabelPropertyName, secondaryDisplayLabelPropertyNames)]
}, {
  id: 'createdAsc',
  textKey: 'automation.testV2.chooseRecordPanel.sort.firstCreated',
  iconName: 'sortAmtAsc',
  getSorts: (primaryDisplayLabelPropertyName, secondaryDisplayLabelPropertyNames) => [{
    property: 'createdate',
    order: 'ASC'
  }, ...getDefaultSorts('ASC', primaryDisplayLabelPropertyName, secondaryDisplayLabelPropertyNames)]
}];
const SortRecordsButton = ({
  value,
  onChange
}) => {
  const currentOption = OPTIONS.find(option => option.id === value) || OPTIONS[0];
  return /*#__PURE__*/_jsx(UIDropdown, {
    buttonClassName: "p-left-0 p-bottom-0",
    buttonUse: "transparent",
    buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: currentOption.textKey
    }),
    children: /*#__PURE__*/_jsx(UIList, {
      children: OPTIONS.map(option => {
        return /*#__PURE__*/_jsxs(UIButton, {
          onClick: () => onChange(option),
          children: [/*#__PURE__*/_jsx(UIIcon, {
            name: option.iconName
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            message: option.textKey
          })]
        }, option.id);
      })
    })
  });
};
export default SortRecordsButton;